export function normalizePhoneDigits(value = '') {
  const digitsOnly = `${value}`.replace(/\D/g, '');
  if (!digitsOnly) return '';

  if (digitsOnly[0] === '1') {
    return digitsOnly.slice(0, 11);
  }

  return digitsOnly.slice(0, 10);
}

export function formatPhoneForDisplay(value = '') {
  const normalized = normalizePhoneDigits(value);
  if (!normalized) return '';

  const hasCountryCode = normalized[0] === '1' && normalized.length > 10;
  const local = hasCountryCode ? normalized.slice(1) : normalized;
  const prefix = hasCountryCode ? '1 ' : '';

  if (local.length < 4) return `${prefix}(${local}`;
  if (local.length < 7) {
    return `${prefix}(${local.slice(0, 3)}) ${local.slice(3)}`;
  }

  return `${prefix}(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 10)}`;
}
